// extracted by mini-css-extract-plugin
var _1 = "min-width-content__K9ILu";
var _2 = "white-space-no-wrap__XaYJT";
export { _1 as "minWidthContent", _2 as "whiteSpaceNoWrap" }
